import { VBtn } from 'vuetify/lib/components/VBtn';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VToolbarItems,[_c(VBtn,{attrs:{"small":"","text":"","to":("" + (_vm.$route.query.plating === '1'?'?':'?plating=1'))}},[_vm._v("Plating ")]),_c(VBtn,{attrs:{"small":"","text":"","to":("" + (_vm.$route.query.prep === '1'?'?':'?prep=1'))}},[_vm._v(" Prep ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }